"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayOffProposalEndpoint = getPayOffProposalEndpoint;
function getPayOffProposalEndpoint() {
    return "/quotation/proposal";
}
//# sourceMappingURL=quotation.js.map